import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import {
  TextQuestion,
  SectionHeader,
  NumberQuestion,
  DateQuestionInternal as DateQuestion,
  DropdownQuestion,
  RadioCheckboxQuestion,
  MatrixQuestion,
  SliderQuestion,
} from 'ecs-react-components/dist/index.es';

import { messages } from './Questionnaires.i18n';

import * as QUESTIONNAIRE_ITEM_TYPES from '../../redux/modules/questionnaires/questionnaire-item-types';

class QuestionnaireContents extends React.Component {
  getItemsWithMatrixGrouped = (questionnaire) => {
    const newItems = [];
    questionnaire.questionnaireItems
      .sort((item1, item2) => item1.sortOrder - item2.sortOrder)
      .map((item) => {
        if (item.questionnaireItemType === QUESTIONNAIRE_ITEM_TYPES.MATRIX_GROUPING &&
            newItems.find((x) => x.questionMatrixGuid === item.questionMatrixGuid) === undefined) {
          newItems.push({
            questionnaireItemType: QUESTIONNAIRE_ITEM_TYPES.MATRIX_GROUPING,
            questionMatrixGuid: item.questionMatrixGuid,
            questionnaireItems: questionnaire.questionnaireItems
              .filter((x) => x.questionMatrixGuid === item.questionMatrixGuid)
              .map((y) => {
                const questionAnswer = questionnaire.patientQuestionAnswerList
                  .find((q) => q.questionnaireItemId === y.questionnaireItemId);
                return {
                  questionnaireItem: y,
                  answer: questionAnswer,
                };
              }),
          });
        } else if (item.questionnaireItemType === QUESTIONNAIRE_ITEM_TYPES.CHECKBOX_QUESTION
          || item.questionnaireItemType === QUESTIONNAIRE_ITEM_TYPES.BOOLEAN_QUESTION
          || item.questionnaireItemType === QUESTIONNAIRE_ITEM_TYPES.RADIOBUTTON_QUESTION) {
          newItems.push({
            questionnaireItemType: item.questionnaireItemType,
            questionnaireItem: item,
            answer: questionnaire.patientQuestionAnswerList
              .filter((x) => x.questionnaireItemId === item.questionnaireItemId),
          });
        } else if (item.questionnaireItemType !== QUESTIONNAIRE_ITEM_TYPES.MATRIX_GROUPING
          && item.questionnaireItemType !== QUESTIONNAIRE_ITEM_TYPES.CHECKBOX_QUESTION
          && item.questionnaireItemType !== QUESTIONNAIRE_ITEM_TYPES.BOOLEAN_QUESTION
          && item.questionnaireItemType !== QUESTIONNAIRE_ITEM_TYPES.RADIOBUTTON_QUESTION) {
          const questionAnswer = questionnaire.patientQuestionAnswerList
            .find((q) => q.questionnaireItemId === item.questionnaireItemId);
          newItems.push({
            questionnaireItemType: item.questionnaireItemType,
            questionnaireItem: item,
            answer: questionAnswer,
          });
        }
        return item;
      });

    return newItems;
  };

  render() {
    const { formatMessage } = this.props.intl;

    return (
      <div>
        {
          this.getItemsWithMatrixGrouped(this.props.questionnaire)
            .map((item) => {
              let itemToRender;
              switch (item.questionnaireItemType) {
                case QUESTIONNAIRE_ITEM_TYPES.TEXT_QUESTION:
                  itemToRender = (
                    <TextQuestion
                      questionnaireItem={ item.questionnaireItem }
                      updateAnswer={ this.updateQuestionnaireAnswer }
                      key={ item.questionnaireItem.questionnaireItemId }
                      validateQuestionnaire={ this.validateQuestionnaireOnChange }
                      disabled={this.props.disabled}
                      answerItem={item.answer}
                    />);
                  break;
                case QUESTIONNAIRE_ITEM_TYPES.SECTION_HEADER:
                  itemToRender = (
                    <SectionHeader
                      id={ item.questionnaireItemId }
                      text={ item.questionnaireItem.formattedText }
                      key={ item.questionnaireItem.questionnaireItemId }
                    />);
                  break;
                case QUESTIONNAIRE_ITEM_TYPES.BOOLEAN_QUESTION:
                case QUESTIONNAIRE_ITEM_TYPES.RADIOBUTTON_QUESTION:
                  itemToRender = (
                    <RadioCheckboxQuestion
                      questionnaireItem={ item.questionnaireItem }
                      updateAnswer={ this.updateQuestionnaireAnswer }
                      key={ item.questionnaireItem.questionnaireItemId }
                      inputType="radio"
                      validateQuestionnaire={ this.validateQuestionnaireOnChange }
                      disabled={this.props.disabled}
                      answerItem={item.answer}
                    />
                  );
                  break;
                case QUESTIONNAIRE_ITEM_TYPES.CHECKBOX_QUESTION:
                  itemToRender = (
                    <RadioCheckboxQuestion
                      questionnaireItem={ item.questionnaireItem }
                      updateAnswer={ this.updateQuestionnaireAnswer }
                      key={ item.questionnaireItem.questionnaireItemId }
                      inputType="checkbox"
                      validateQuestionnaire={ this.validateQuestionnaireOnChange }
                      disabled={this.props.disabled}
                      answerItem={item.answer}
                    />
                  );
                  break;
                case QUESTIONNAIRE_ITEM_TYPES.DROPDOWN_QUESTION:
                  itemToRender = (
                    <DropdownQuestion
                      questionnaireItem={ item.questionnaireItem }
                      updateAnswer={ this.updateQuestionnaireAnswer }
                      key={ item.questionnaireItem.questionnaireItemId }
                      validateQuestionnaire={ this.validateQuestionnaireOnChange }
                      disabled={this.props.disabled}
                      answerItem={item.answer}
                    />
                  );
                  break;
                case QUESTIONNAIRE_ITEM_TYPES.NUMBER_QUESTION:
                  itemToRender = (
                    <NumberQuestion
                      questionnaireItem={ item.questionnaireItem }
                      updateAnswer={ this.updateQuestionnaireAnswer }
                      key={ item.questionnaireItem.questionnaireItemId }
                      validateQuestionnaire={ this.validateQuestionnaireOnChange }
                      disabled={this.props.disabled}
                      answerItem={item.answer}
                    />
                  );
                  break;
                case QUESTIONNAIRE_ITEM_TYPES.DATE_QUESTION:
                  itemToRender = (
                    <DateQuestion
                      questionnaireItem={ item.questionnaireItem }
                      updateAnswer={ this.updateQuestionnaireAnswer }
                      key={ item.questionnaireItem.questionnaireItemId }
                      language={ this.props.language }
                      validateQuestionnaire={ this.validateQuestionnaireOnChange }
                      disabled={this.props.disabled}
                      answerItem={item.answer}
                      dateQuestionLabel={ formatMessage(messages.labels.dateDropdown) }
                    />
                  );
                  break;
                case QUESTIONNAIRE_ITEM_TYPES.SLIDER_QUESTION:
                  itemToRender = (
                    <SliderQuestion
                      questionnaireItem={ item.questionnaireItem }
                      updateAnswer={ this.updateQuestionnaireAnswer }
                      key={ item.questionnaireItem.questionnaireItemId }
                      validateQuestionnaire={ this.validateQuestionnaireOnChange }
                      disabled={this.props.disabled}
                      answerItem={item.answer}
                    />
                  );
                  break;
                case QUESTIONNAIRE_ITEM_TYPES.MATRIX_GROUPING:
                  itemToRender = (
                    <MatrixQuestion
                      questionnaireItems={ item.questionnaireItems }
                      updateAnswer={ this.updateQuestionnaireAnswer }
                      key={ item.questionMatrixGuid }
                      validateQuestionnaire={ this.validateQuestionnaireOnChange }
                      disabled={this.props.disabled}
                    />
                  );
                  break;
                default:
                  itemToRender = null;
              }
              return itemToRender;
            })
        }
      </div>
    );
  }
}

QuestionnaireContents.propTypes = {
  questionnaire: PropTypes.object,
  language: PropTypes.string,
  disabled: PropTypes.bool,
  intl: PropTypes.object,
};

const mapStateToProps = (state) => ({
  language: state.language.languageCode,
});

export default connect(mapStateToProps)(injectIntl(QuestionnaireContents));